import { renderInDocument } from '@spotahome/soyuz/client';

import LandingPageContainer from './main';

renderInDocument(LandingPageContainer);
